import { useCompleteEvaluationData } from '../useCompleteEvaluationData'
import { useDispatch, useSelector } from 'react-redux'
import { setEvaluations } from '../../redux/evaluations'
import { resetImages } from '../../redux/images'

const revokeSlotUrls = (slot) => {
  if (slot.image) URL.revokeObjectURL(slot.image)
  if (slot.heatMapImage) {
    if (slot.heatMapImage.NHM) URL.revokeObjectURL(slot.heatMapImage.NHM)
    if (slot.heatMapImage.HM) URL.revokeObjectURL(slot.heatMapImage.HM)
  }
}

export const useSetCase = () => {
  const { user, images } = useSelector(state => state)
  const { completeEvaluationData } = useCompleteEvaluationData()
  const dispatch = useDispatch()

  const setCase = async (singleCase) => {
    images.leftEye.images.forEach(revokeSlotUrls)
    images.rightEye.images.forEach(revokeSlotUrls)
    dispatch(resetImages())
    if (user.role === 'patient') {
      dispatch(setEvaluations(singleCase))
      await completeEvaluationData(singleCase, 'patient-readonly')
    }
    // Cuando se quiera incorporar la funcion del oftalmologo...
    if (user.role === 'technical') {
      dispatch(setEvaluations(singleCase))
      await completeEvaluationData(singleCase, 'last')
    }

    if (user.role === 'ophthalmologist') {
      dispatch(setEvaluations(singleCase))
      await completeEvaluationData(singleCase, '')
    }
  }

  return { setCase }
}
